import { Fragment, useEffect, useState } from "react";

import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

import PDFViewer from "../Actions/PDFViewer";
import FileDropSupplemental from "../Shared/DropDown/FileDropSupplemental";

const Supplemental = ({ meeting, update }) => {
  const [mobileFile, setMobileFile] = useState();
  const [resources, setResources] = useState([]);

  useEffect(() => {
    if (meeting) {
      setResources(meeting.attachments);
      setMobileFile(meeting.attachments[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  const handleFileChange = (value) => {
    setMobileFile(value);
  };

  return (
    <Transition.Root show={true} appear={true} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed inset-0 overflow-hidden z-50"
        onClose={() => update({ visible: false, meeting: null })}
      >
        <div className="absolute inset-0 overflow-hidden">
          <Dialog.Overlay className="hidden xl:absolute xl:inset-0 bg-gray-500 bg-opacity-80" />

          <div className="fixed inset-y-0 right-0 xl:pl-10 max-w-full flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="w-screen xl:max-w-6xl 2xl:max-w-[104em] bg-zinc-50">
                <div className="h-full">
                  {/* Header */}
                  <div className="px-4 pt-6 sm:px-6 border-b border-zinc-700 pb-1">
                    <div className="flex items-start justify-between space-x-3">
                      <div className="space-y-1">
                        <Dialog.Title className="2xl:text-lg flex font-medium text-black">
                          <span className="text-lg 2xl:text-xl">
                            {meeting?.scheduleDate} Supplemental Resources
                          </span>
                        </Dialog.Title>
                      </div>
                      <div className="h-7 flex items-center">
                        <button
                          type="button"
                          className="rounded-md text-black hover:text-delete-btn focus:outline-none cursor-pointer hover:rotate-180 transform duration-150"
                          onClick={() =>
                            update({ visible: false, meeting: null })
                          }
                        >
                          <span className="sr-only">Close panel</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-4 h-full">
                    {/* Resources */}
                    {resources?.length > 0 && mobileFile && (
                      <div className="px-6 col-span-4 mt-2">
                        <FileDropSupplemental
                          array={resources}
                          value={mobileFile}
                          change={handleFileChange}
                          heading="Choose File"
                        />
                      </div>
                    )}
                    {mobileFile && (
                      <div className="col-span-4 h-screen pb-[150px] overflow-y-auto">
                        <PDFViewer urlFile={mobileFile} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Supplemental;
